<div class="comments-wrapper">
  <div class="header">{{ "gallery.comments" | translate }}</div>
  <div
    #commentsList
    *ngIf="commentsList as comments; else loadingOrError"
    class="comments"
  >
    <ng-container *ngIf="comments.length > 0; else noContent">
      <ng-container *ngFor="let comment of comments; trackBy: trackByFn">
        <ks-comment
          (comparePhoto)="onComparePhoto($event)"
          (longerTask)="longTask($event)"
          [comment]="comment"
          [user]="user"
          class="comment-gallery"
        ></ks-comment>
      </ng-container>
    </ng-container>

    <ng-template #noContent>
      <div class="comments__loading comments__loading__no-content">
        {{ "gallery.no_comments" | translate }}
      </div>
    </ng-template>
  </div>
</div>
<ks-sender
  (onSendMessage)="sendMessage($event)"
  [(formStatus)]="sendFormStatus"
  [imageId]="id"
  [isAllowCreateTask]="isAllowCreateTask"
></ks-sender>

<ng-template #loadingOrError>
  <div
    *ngIf="loadingError$ | async as error; else loading"
    class="comments__loading"
  >
    <span class="color-red">{{ error }}</span>
  </div>
  <ng-template #loading>
    <div class="comments__loading">
      <fa-icon [icon]="['fas', 'spinner']" class="tr-spin"></fa-icon>
    </div>
  </ng-template>
</ng-template>
